import * as React from "react";

import {getPromptVariable} from "@khan/guide-core-helpers";
import {Guide, HIDE_CHAT_NO_MESSAGE} from "@khan/guide-ui";

import useMediaQuery from "./hooks/use-media-query.ts";

type Props = {
    requireClassroomSelection?: boolean;
};

export default function ChatOnlyTool({requireClassroomSelection}: Props) {
    const largeScreen = useMediaQuery("(min-width: 768px)");

    // We hide the chat input for tools that require classroom selection to
    // enforce that the first interaction from a user be via action bubble to
    // set their class.
    const [hideChatInput, setHideChatInput] = React.useState(true);
    const hasSetClassroomDescriptor = getPromptVariable("classroomDescriptor");
    if (
        hideChatInput &&
        (hasSetClassroomDescriptor || !requireClassroomSelection)
    ) {
        setHideChatInput(false);
    }

    return (
        <Guide
            expanded={largeScreen}
            forceHideChatOptions={
                hideChatInput ? HIDE_CHAT_NO_MESSAGE : undefined
            }
            skipSpeechOnboarding={true}
        />
    );
}
